export default __webpack_public_path__ + "static/media/waldo.be8b1bf4.svg";